import React, { useEffect, useState } from 'react'
import {
  Tab,
  Nav,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import _ from "lodash";
import cx from "classnames";

import { fetchPaletteIds } from 'actions/brandKit/brandKit';
import { useHistory } from "react-router-dom";

import MediaElement from './elements/media';
import ColoursElement from './elements/colour';
import ButtonsElement from './elements/button';
import IconElement from './elements/icon';
import TextElement from './elements/text';
import ComponentsBrandkit from './elements/components';

import styles from './brandkit.module.scss'
import { MIXPANEL_PAGE_VIEWED, MIXPANEL_PAGE_VIEWED_FORM_BRANDKIT } from 'constants/mixpanelEvents';
import { createMixpanelEvent } from 'actions/mixpanel';
import { getPageViewedEventPayload } from 'services/mixpanelUtil';



export default function BrandKitView(props) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchPaletteIds());
    var mixPanelPayload = getPageViewedEventPayload(MIXPANEL_PAGE_VIEWED_FORM_BRANDKIT)
    dispatch(createMixpanelEvent(MIXPANEL_PAGE_VIEWED, mixPanelPayload))    
  }, []);

  return (
    <div className={styles.brandKitContainer}>
      <BrandKitListView />
    </div>
  )
}

function BrandKitListView() {
  const workspace = useSelector((state) => _.get(state, "workspaces.workspace.item"));
  const history = useHistory();
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const handleClick = (type) => {
    history.push(`/app/${workspace.id}/integration-settings/brand-kit?type=${type}`);
  }

  var eventKey = null;

  if (urlParams.get('type')) {
    eventKey = urlParams.get('type');
  }

  if(!eventKey) {
    eventKey = 'media';
  }

  return (
    <div className={styles.content}>
      <header className={styles.header}>
        <div className={styles.wrapper}>
          <h1>Brand Kit</h1>
          <span>One space to manage them all</span>
        </div>
      </header>

      <div className={styles.brandKitManagement}>
        <Tab.Container id="brand-kit-management-tab" defaultActiveKey={eventKey}>
          <header className={styles.brandKitManagementHeader}>
            <Nav variant="pills" className={styles.brandKitManagementTab}>
              <Nav.Item>
                <Nav.Link eventKey="media" onClick={() => { handleClick("media") }}><div className={styles.logoContainer}>
                <i className={cx(styles.icon, 'cleverstory-background')} />
                </div>Media</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="icons" onClick={() => { handleClick("icons") }}><div className={styles.logoContainer}>
                <i className={cx(styles.icon, 'cleverstory-file-type')} />
                </div>Icons</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="colours" onClick={() => { handleClick("colours") }}><div className={styles.logoContainer}>
                <i className={cx(styles.icon, 'cleverstory-font-color')} />
                </div>Colours</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="text" onClick={() => { handleClick("text") }}><div className={styles.logoContainer}>
                <i className={cx(styles.textLayerIcon, 'cleverstory-text-layer')} />
                </div>Text</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="button" onClick={() => { handleClick("button") }}><div className={styles.logoContainer}>
                <i className={cx(styles.arrowIcon, 'cleverstory-button-arrow')} />
                </div>Button</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="components" onClick={() => { handleClick("components") }}><div className={styles.logoContainer}>
                  <i className={cx(styles.icon, 'cleverstory-components')} />
                  </div>Components</Nav.Link>
              </Nav.Item>
            </Nav>
            <section
              className={cx(styles.buttonContainer, styles.primaryActions)} >
            </section>
          </header>

          <div className={cx(styles.brandKitContentContainer)}>
            <div className={styles.listView}>
              <Tab.Content>
            <Tab.Pane eventKey="media">
              <MediaElement/>
            </Tab.Pane>
            <Tab.Pane eventKey="icons">
              <IconElement/>
            </Tab.Pane>
            <Tab.Pane eventKey="colours">
              <ColoursElement/>            
            </Tab.Pane>
            <Tab.Pane eventKey="text">
              <TextElement/>
            </Tab.Pane>
            <Tab.Pane eventKey="button">
              <ButtonsElement/>
            </Tab.Pane>
            <Tab.Pane eventKey="components">
              <ComponentsBrandkit/>
            </Tab.Pane>
              </Tab.Content>
            </div>
          </div>
        </Tab.Container>
      </div>
    </div>
  );
}